import React, { useState } from "react";
import { useNavigate, Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Sparkles, Loader2, TrendingUp, Wallet, PiggyBank } from "lucide-react";

export default function Login() {
  const { user, login } = useAuth();
  const navigate = useNavigate();
  const [username, setUsername] = useState("admin");
  const [password, setPassword] = useState("admin123");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  if (user && user !== false) return <Navigate to="/" replace />;

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    const res = await login(username.trim(), password);
    setLoading(false);
    if (res.ok) navigate("/");
    else setError(res.error || "Giriş başarısız");
  };

  return (
    <div className="min-h-screen flex" data-testid="login-page">
      {/* Left panel: form */}
      <div className="w-full lg:w-[520px] flex items-center justify-center px-8 py-12 bg-[#0B0F19] relative z-10">
        <div className="w-full max-w-md slide-up">
          <div className="flex items-center gap-3 mb-10">
            <div className="w-12 h-12 rounded-2xl bg-gradient-to-br from-indigo-500 to-emerald-500 flex items-center justify-center glow-primary">
              <Sparkles className="w-6 h-6 text-white" />
            </div>
            <div>
              <div className="font-bold text-2xl tracking-tight" style={{ fontFamily: "'Plus Jakarta Sans', sans-serif" }}>Fintr</div>
              <div className="text-xs text-[#94A3B8]">Finansal Yönetim Platformu</div>
            </div>
          </div>

          <h1 className="text-4xl font-bold mb-3" style={{ fontFamily: "'Plus Jakarta Sans', sans-serif" }}>
            Tekrar hoş geldiniz
          </h1>
          <p className="text-[#94A3B8] mb-8 text-sm">
            Nakit akışınızı, gelirlerinizi ve giderlerinizi tek yerden yönetin.
          </p>

          <form onSubmit={handleSubmit} className="space-y-5" data-testid="login-form">
            <div>
              <Label htmlFor="username" className="text-sm text-[#94A3B8] mb-2 block">Kullanıcı Adı</Label>
              <Input
                id="username"
                data-testid="login-username-input"
                autoComplete="username"
                value={username}
                onChange={(e) => setUsername(e.target.value)}
                className="bg-[#131D31] border-[#1E293B] text-white h-12 focus-visible:ring-indigo-500"
                placeholder="admin"
              />
            </div>
            <div>
              <Label htmlFor="password" className="text-sm text-[#94A3B8] mb-2 block">Şifre</Label>
              <Input
                id="password"
                type="password"
                data-testid="login-password-input"
                autoComplete="current-password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                className="bg-[#131D31] border-[#1E293B] text-white h-12 focus-visible:ring-indigo-500"
                placeholder="••••••••"
              />
            </div>

            {error && (
              <div data-testid="login-error" className="text-sm text-red-400 bg-red-500/10 border border-red-500/30 rounded-lg px-3 py-2">
                {error}
              </div>
            )}

            <Button
              type="submit"
              data-testid="login-submit-button"
              disabled={loading}
              className="w-full h-12 bg-indigo-500 hover:bg-indigo-600 text-white font-semibold glow-primary"
            >
              {loading ? <Loader2 className="w-4 h-4 animate-spin" /> : "Giriş Yap"}
            </Button>

            <div className="text-xs text-[#64748B] text-center pt-2">
              Demo erişimi: <span className="mono text-[#94A3B8]">admin / admin123</span>
            </div>
          </form>
        </div>
      </div>

      {/* Right panel: visual */}
      <div className="hidden lg:flex flex-1 relative overflow-hidden subtle-grid-bg items-center justify-center p-12">
        <div className="absolute inset-0 bg-gradient-to-br from-indigo-500/10 via-transparent to-emerald-500/10" />
        <div className="relative z-10 max-w-lg">
          <div className="text-sm uppercase tracking-widest text-indigo-400 mb-4">Modern Nakit Akışı</div>
          <h2 className="text-5xl font-bold mb-6 leading-tight" style={{ fontFamily: "'Plus Jakarta Sans', sans-serif" }}>
            Finansınızı <span className="text-gradient">anlık</span><br />tek yerden yönetin
          </h2>
          <p className="text-[#94A3B8] mb-10">
            Çoklu para birimi, cari hesap takibi, yaklaşan tahsilat ve ödeme hatırlatıcıları, Excel ile toplu veri aktarımı.
          </p>
          <div className="grid grid-cols-3 gap-4">
            <div className="card-elev p-5">
              <TrendingUp className="w-6 h-6 text-emerald-400 mb-3" />
              <div className="font-semibold text-sm">Anlık Rapor</div>
              <div className="text-xs text-[#94A3B8] mt-1">30 günlük akış</div>
            </div>
            <div className="card-elev p-5">
              <Wallet className="w-6 h-6 text-indigo-400 mb-3" />
              <div className="font-semibold text-sm">Çoklu Döviz</div>
              <div className="text-xs text-[#94A3B8] mt-1">TRY · USD · EUR</div>
            </div>
            <div className="card-elev p-5">
              <PiggyBank className="w-6 h-6 text-amber-400 mb-3" />
              <div className="font-semibold text-sm">Cari Takip</div>
              <div className="text-xs text-[#94A3B8] mt-1">Müşteri + Tedarikçi</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
